import React from 'react';
import { type StyleProp, type ViewStyle } from 'react-native';

import { Stack } from '@/components/layout';
import { Text } from '@/components/ui';
import { createStyles, useScaling } from '@/hooks';
import { guardianColors } from '@/theme/colors';

type SecuritySectionProps = {
  title: string;
  children: React.ReactNode;
  style?: StyleProp<ViewStyle>;
};

export function SecuritySection({ title, children, style }: SecuritySectionProps) {
  const { scale } = useScaling();
  const styles = useStyles();

  return (
    <Stack gap={scale({ phone: 12, tablet: 16 })} style={style}>
      <Text variant="Font Guardian App/Body/Body 16 Bold" style={styles.title}>
        {title}
      </Text>
      {children}
    </Stack>
  );
}

const useStyles = createStyles(() => ({
  title: {
    color: guardianColors['10'],
  },
}));
